import * as signalR from "@microsoft/signalr";
import ApiConfig from "../../utils/ApiConfig";

export const connection = new signalR.HubConnectionBuilder()
  .withUrl(ApiConfig.getUrl("chatHub"))
  // .withUrl("https://localhost:7147/chatHub")
  .withAutomaticReconnect()
  .build();